import DeepLink from 'src/modules/10-app/deep-links';
const DeepLinkAPIs = {
    open: DeepLink.open,
};
export default DeepLinkAPIs;
